// WineHoliday Delivery Flow — Area-first v8
// Compatible with:
// - custom searchable town picker
// - automatic delivery window by town
// - WhatsApp prefix + number selector
// - filtered town groups on search
// - legacy-compatible cart attributes for emails, Make and Google Sheets
// - compact delivery policy note + mandatory Shipping Policy checkbox
// - saves delivery_policy_accepted via /cart/update.js

(function () {
  function parseLocalDate(dateString) {
    if (!dateString) return null;
    return new Date(dateString + 'T00:00:00');
  }

  function formatDateForInput(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function getTodayAtMidnight() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  function getTomorrowAtMidnight() {
    const tomorrow = getTodayAtMidnight();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  }

  function isDeliveryDayAllowed(dateString, area) {
  const date = parseLocalDate(dateString);
  if (!date) return false;

  const day = date.getDay();
  const normalizedArea = String(area || '').trim().toUpperCase();

  // Areas A/B: every day except Tuesday
  if (normalizedArea === 'AREA_A' || normalizedArea === 'AREA_B') {
    return day !== 2;
  }

  // Areas C/D/E/F/G: Monday, Wednesday, Thursday and Friday only
  if (
    ['AREA_C', 'AREA_D', 'AREA_E', 'AREA_F', 'AREA_G'].includes(normalizedArea)
  ) {
    return [1, 3, 4, 5].includes(day);
  }

  // No valid delivery area selected
  return false;
}

  function isPastOrToday(dateString) {
    const selectedDate = parseLocalDate(dateString);
    if (!selectedDate) return true;

    const tomorrow = getTomorrowAtMidnight();
    return selectedDate < tomorrow;
  }

  function isClosedDate(dateString, area) {
    if (!dateString || !Array.isArray(window.WH_DELIVERY_CLOSURES)) {
      return false;
    }

    return window.WH_DELIVERY_CLOSURES.some(function (closure) {
      if (!closure || closure.date !== dateString) return false;

      const scope = String(closure.scope || '').trim().toUpperCase();
const closureArea = String(closure.area || '').trim().toUpperCase();
const selectedArea = String(area || '').trim().toUpperCase();

if (scope === 'FULL_DAY') return true;
if (closureArea === 'ALL') return true;

if (
  scope === 'AREA_ONLY' &&
  selectedArea &&
  closureArea === selectedArea
) {
  return true;
}

return false;
    });
  }
function setDateVisualStatus(dateInput, status) {
  if (!dateInput) return;

  dateInput.classList.remove(
    'wh-date-available',
    'wh-date-unavailable',
    'wh-date-soldout'
  );

  if (status === 'available') {
    dateInput.classList.add('wh-date-available');
  }

  if (status === 'unavailable') {
    dateInput.classList.add('wh-date-unavailable');
  }

  if (status === 'soldout') {
    dateInput.classList.add('wh-date-soldout');
  }
}
  function setInputValue(input, value) {
    if (!input) return;
    input.value = value || '';
  }

  function cleanPhoneNumber(number) {
    if (!number) return '';

    return String(number)
      .trim()
      .replace(/\s+/g, '')
      .replace(/[().-]/g, '')
      .replace(/^00/, '+');
  }

  function buildWhatsappNumber(prefixInput, numberInput) {
    const prefix = prefixInput ? String(prefixInput.value || '').trim() : '';
    let number = numberInput ? cleanPhoneNumber(numberInput.value) : '';

    if (!prefix || !number) return '';

    if (number.indexOf('+') === 0) {
      return number;
    }

    number = number.replace(/^\+/, '');

    return prefix + number;
  }

  function getSelectedTownData(townInput) {
    if (!townInput || !townInput.value) {
      return {
        town: '',
        area: '',
        windowCode: '',
        windowFull: ''
      };
    }

    return {
      town: townInput.value || '',
      area: townInput.dataset.area || '',
      windowCode: townInput.dataset.window || '',
      windowFull: townInput.dataset.windowFull || ''
    };
  }

  function updateTownGroupVisibility() {
    document.querySelectorAll('.wh-town-picker__group').forEach(function (group) {
      let hasVisibleTown = false;
      let nextElement = group.nextElementSibling;

      while (nextElement && !nextElement.classList.contains('wh-town-picker__group')) {
        if (
          nextElement.classList &&
          nextElement.classList.contains('wh-town-option') &&
          nextElement.style.display !== 'none'
        ) {
          hasVisibleTown = true;
          break;
        }

        nextElement = nextElement.nextElementSibling;
      }

      group.style.display = hasVisibleTown ? 'block' : 'none';
    });
  }

  function showAllTownGroups() {
    document.querySelectorAll('.wh-town-picker__group').forEach(function (group) {
      group.style.display = 'block';
    });
  }

  function initWineHolidayDeliveryFlow() {
    const deliveryBlock = document.getElementById('wh-delivery-details');

    if (!deliveryBlock) return;

    const cartForm = document.getElementById('cart');
    const checkoutButton = document.getElementById('checkout');

    let isSubmittingAfterPolicySave = false;

    const townInput = document.getElementById('wh-delivery-town');
    const townPickerButton = document.getElementById('wh-town-picker-button');
    const townPickerLabel = document.getElementById('wh-town-picker-label');
    const townPickerPanel = document.getElementById('wh-town-picker-panel');
    const townSearch = document.getElementById('wh-town-search');
    const townOptions = document.querySelectorAll('.wh-town-option');

    const accommodationNameInput = document.getElementById('wh-accommodation-name');
    const fullAddressInput = document.getElementById('wh-full-delivery-address');
    const deliveryDateInput = document.getElementById('wh-delivery-date');
    const deliveryNotesInput = document.getElementById('wh-delivery-notes');

    function hasFreshMeatProductInCart() {
  const cartProductLinks = document.querySelectorAll('a[href*="/products/"]');
  const cartItemNames = document.querySelectorAll('.cart-item__name');

  let cartDomHasProductLines = cartProductLinks.length > 0 || cartItemNames.length > 0;
  let cartDomHasFreshMeat = false;

  cartProductLinks.forEach(function (link) {
    const href = link.getAttribute('href') || '';
    if (href.indexOf('/products/piemonte-bbq-box-for-two') !== -1) {
      cartDomHasFreshMeat = true;
    }
  });

  cartItemNames.forEach(function (itemName) {
    const text = itemName.textContent || '';
    if (text.indexOf('Piemonte BBQ Box for Two') !== -1) {
      cartDomHasFreshMeat = true;
    }
  });

  if (cartDomHasProductLines) {
    return cartDomHasFreshMeat;
  }

  return window.WH_HAS_FRESH_MEAT_PRODUCT === true;
}

function getRomeNowParts() {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Rome',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    hourCycle: 'h23'
  }).formatToParts(new Date());

  const out = {};

  parts.forEach(function(part) {
    if (part.type !== 'literal') {
      out[part.type] = Number(part.value);
    }
  });

  if (out.hour === 24) {
    out.hour = 0;
  }

  return out;
}

function ymdToParts(dateStr) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  if (!match) return null;

  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3])
  };
}

function partsToNumber(parts) {
  return (
    parts.year * 10000000000 +
    parts.month * 100000000 +
    parts.day * 1000000 +
    (parts.hour || 0) * 10000 +
    (parts.minute || 0) * 100 +
    (parts.second || 0)
  );
}

function validateFreshMeatDeadline(selectedDateStr) {
  const selectedParts = ymdToParts(selectedDateStr);
  if (!selectedParts) return true;

  const selectedDate = new Date(Date.UTC(
    selectedParts.year,
    selectedParts.month - 1,
    selectedParts.day
  ));

  const selectedDay = selectedDate.getUTCDay(); // 0 = Sunday

  const cutoffDate = new Date(selectedDate);

  if (selectedDay === 0) {
    // Sunday delivery: order must be placed by Friday 23:59 Rome time
    cutoffDate.setUTCDate(cutoffDate.getUTCDate() - 2);
  } else {
    // Other delivery days: order must be placed by 23:59 the day before
    cutoffDate.setUTCDate(cutoffDate.getUTCDate() - 1);
  }

  const cutoffParts = {
    year: cutoffDate.getUTCFullYear(),
    month: cutoffDate.getUTCMonth() + 1,
    day: cutoffDate.getUTCDate(),
    hour: 23,
    minute: 59,
    second: 59
  };

  return partsToNumber(getRomeNowParts()) <= partsToNumber(cutoffParts);
}

function showFreshMeatDeadlineError() {
  const message =
    'BBQ products are prepared fresh by our butcher.<br><br>' +
    'For next-day delivery, please order by 23:59 the day before.<br><br>' +
    'For Sunday delivery, BBQ products must be ordered by Friday at 23:59 because our butcher is closed on Sundays.<br><br>' +
    'Please choose another delivery date or remove the BBQ product from your cart.';

  if (errorBox) {
    errorBox.dataset.whErrorType = 'fresh-meat';
    errorBox.innerHTML = message;
    errorBox.style.display = 'block';
    errorBox.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  } else {
    alert(message.replace(/<br><br>/g, '\n\n'));
  }
}

    const customerWhatsappInput = document.getElementById('wh-customer-whatsapp');
    const customerWhatsappPrefix = document.getElementById('wh-whatsapp-prefix');
    const customerWhatsappNumber = document.getElementById('wh-customer-whatsapp-number');

    const deliveryAreaInput = document.getElementById('wh-delivery-area');
    const deliveryWindowInput = document.getElementById('wh-delivery-window');
    const deliveryWindowFullInput = document.getElementById('wh-delivery-window-full');

    const deliveryWindowDisplay = document.getElementById('wh-delivery-window-display');
    const suggestedVilla = document.getElementById('wh-checkout-suggested-villa');
    const suggestedAddress = document.getElementById('wh-checkout-suggested-address');

    const villaNameLegacyInput = document.getElementById('wh-villa-name-legacy');
    const fullAddressLegacyInput = document.getElementById('wh-full-address');
    const accommodationAddressLegacyInput = document.getElementById('wh-accommodation-address');
    const customerPhoneLegacyInput = document.getElementById('wh-customer-phone');

    const errorBox = document.getElementById('wh-error');
    const dateErrorBox = document.getElementById('wh-date-error');

    function insertDeliveryPolicyNoteStyles() {
      if (document.getElementById('wh-delivery-policy-note-styles')) return;

      const style = document.createElement('style');
      style.id = 'wh-delivery-policy-note-styles';

      style.textContent =
        '.wh-delivery-policy-note {' +
          'margin-top: 12px;' +
          'margin-bottom: 12px;' +
          'padding: 10px 12px;' +
          'border: 1px solid rgba(120, 80, 40, 0.22);' +
          'border-radius: 8px;' +
          'background: rgba(120, 80, 40, 0.045);' +
          'font-size: 12.5px;' +
          'line-height: 1.35;' +
        '}' +
        '.wh-delivery-policy-note strong {' +
          'display: block;' +
          'margin-bottom: 6px;' +
          'font-size: 13px;' +
        '}' +
        '.wh-delivery-policy-note p {' +
          'margin: 0 0 7px;' +
        '}' +
        '.wh-delivery-policy-note p:last-child {' +
          'margin-bottom: 0;' +
        '}' +
        '.wh-delivery-policy-check {' +
          'display: flex;' +
          'align-items: flex-start;' +
          'gap: 8px;' +
          'margin-top: 8px;' +
          'font-size: 12.5px;' +
          'line-height: 1.35;' +
          'cursor: pointer;' +
        '}' +
        '.wh-delivery-policy-check input {' +
          'margin-top: 2px;' +
          'flex-shrink: 0;' +
        '}' +
        '.wh-delivery-policy-check a {' +
          'text-decoration: underline;' +
        '}' +
        '.wh-delivery-policy-error {' +
          'display: none;' +
          'margin-top: 6px;' +
          'font-size: 12px;' +
          'color: #9a3412;' +
        '}';

      document.head.appendChild(style);
    }

    function getDeliveryPolicyCheckbox() {
      return document.getElementById('wh-delivery-policy-accepted');
    }

    function getDeliveryPolicyHiddenInput() {
      return document.getElementById('wh-delivery-policy-accepted-attribute');
    }

    function updateDeliveryPolicyAttribute() {
      const checkbox = getDeliveryPolicyCheckbox();
      const hiddenInput = getDeliveryPolicyHiddenInput();

      const accepted = Boolean(checkbox && checkbox.checked);

      if (hiddenInput) {
        hiddenInput.value = accepted ? 'YES' : 'NO';
      }

      return accepted;
    }

    function saveDeliveryPolicyAttributeToCart() {
      const accepted = updateDeliveryPolicyAttribute();
      const value = accepted ? 'YES' : 'NO';

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            delivery_policy_accepted: value
          }
        })
      }).catch(function (error) {
        console.warn('WineHoliday: delivery_policy_accepted could not be saved to cart.', error);
      });
    }

    function updateDeliveryPolicyError(showError) {
      const accepted = updateDeliveryPolicyAttribute();
      const policyErrorBox = document.getElementById('wh-delivery-policy-error');

      if (policyErrorBox) {
        policyErrorBox.style.display = !accepted && showError ? 'block' : 'none';
      }

      return accepted;
    }

    function insertDeliveryPolicyNote() {
      if (!deliveryBlock) return;

      insertDeliveryPolicyNoteStyles();

      if (document.getElementById('wh-delivery-policy-note')) return;

      const policyNote = document.createElement('div');
      policyNote.id = 'wh-delivery-policy-note';
      policyNote.className = 'wh-delivery-policy-note';

      policyNote.innerHTML =
        '<strong>Important delivery condition</strong>' +
        '<p>Please make sure someone is available during your delivery window and reachable on WhatsApp.</p>' +
        '<label class="wh-delivery-policy-check" for="wh-delivery-policy-accepted">' +
          '<input type="checkbox" id="wh-delivery-policy-accepted">' +
          '<span>I confirm that I am 18+ and that an adult will be available to receive the order. I have read and accept the <a href="/policies/shipping-policy" target="_blank" rel="noopener">Shipping Policy</a>, including customer availability, age verification and failed delivery conditions.</span>' +
        '</label>' +
        '<div id="wh-delivery-policy-error" class="wh-delivery-policy-error">Please confirm the 18+ delivery condition and accept the Shipping Policy before checkout.</div>' +
        '<input type="hidden" id="wh-delivery-policy-accepted-attribute" name="attributes[delivery_policy_accepted]" value="NO">';

      const insertAfterElement = deliveryNotesInput || deliveryDateInput || fullAddressInput || deliveryWindowDisplay;

      if (insertAfterElement && insertAfterElement.parentNode) {
        insertAfterElement.parentNode.insertBefore(policyNote, insertAfterElement.nextSibling);
      } else {
        deliveryBlock.appendChild(policyNote);
      }

      const checkbox = getDeliveryPolicyCheckbox();

      if (checkbox && !checkbox.dataset.whBound) {
        checkbox.dataset.whBound = 'true';

        checkbox.addEventListener('change', function () {
          updateDeliveryPolicyAttribute();
          saveDeliveryPolicyAttributeToCart();
          updateCheckoutState();
        });
      }

      updateDeliveryPolicyAttribute();
    }

    function setMinimumDeliveryDate() {
      if (!deliveryDateInput) return;

      const tomorrow = getTomorrowAtMidnight();
      deliveryDateInput.min = formatDateForInput(tomorrow);
    }

    function updateWhatsappHiddenValues() {
      const whatsapp = buildWhatsappNumber(customerWhatsappPrefix, customerWhatsappNumber);

      setInputValue(customerWhatsappInput, whatsapp);
      setInputValue(customerPhoneLegacyInput, whatsapp);

      return whatsapp;
    }

    function updateLegacyAttributes() {
      const accommodationName = accommodationNameInput ? accommodationNameInput.value.trim() : '';
      const fullAddress = fullAddressInput ? fullAddressInput.value.trim() : '';

      setInputValue(villaNameLegacyInput, accommodationName);
      setInputValue(fullAddressLegacyInput, fullAddress);
      setInputValue(accommodationAddressLegacyInput, fullAddress);

      updateWhatsappHiddenValues();
    }

    function updateCheckoutInfoBox() {
  const accommodationName = accommodationNameInput ? accommodationNameInput.value.trim() : '';
  const fullAddress = fullAddressInput ? fullAddressInput.value.trim() : '';
  const selectedTown = townInput ? townInput.value.trim() : '';

  if (suggestedVilla) {
    suggestedVilla.textContent = accommodationName || 'Enter your accommodation name above.';
  }

  if (suggestedAddress) {
    const checkoutAddress = [fullAddress, selectedTown].filter(Boolean).join(', ');
    suggestedAddress.textContent = checkoutAddress || 'Enter the full delivery address above.';
  }
}
function saveDeliveryFormToSession() {
  try {
    const checkbox = getDeliveryPolicyCheckbox();

    const data = {
      town: townInput ? townInput.value : '',
      area: townInput ? townInput.dataset.area || '' : '',
      windowCode: townInput ? townInput.dataset.window || '' : '',
      windowFull: townInput ? townInput.dataset.windowFull || '' : '',
      accommodationName: accommodationNameInput ? accommodationNameInput.value : '',
      fullAddress: fullAddressInput ? fullAddressInput.value : '',
      deliveryDate: deliveryDateInput ? deliveryDateInput.value : '',
      whatsappPrefix: customerWhatsappPrefix ? customerWhatsappPrefix.value : '',
      whatsappNumber: customerWhatsappNumber ? customerWhatsappNumber.value : '',
      deliveryNotes: deliveryNotesInput ? deliveryNotesInput.value : '',
      policyAccepted: checkbox && checkbox.checked ? 'YES' : 'NO'
    };

    sessionStorage.setItem('WH_DELIVERY_FORM_DRAFT', JSON.stringify(data));
  } catch (error) {
    console.warn('WineHoliday: could not save delivery form draft.', error);
  }
}

function restoreDeliveryFormFromSession() {
  try {
    const raw = sessionStorage.getItem('WH_DELIVERY_FORM_DRAFT');
    if (!raw) return;

    const data = JSON.parse(raw);

    if (data.town && townInput) {
      const matchingTownButton = Array.from(townOptions).find(function (button) {
        return (
          button.dataset.value === data.town ||
          button.textContent.trim() === data.town
        );
      });

      if (matchingTownButton) {
        selectTown(matchingTownButton);
      } else {
        townInput.value = data.town || '';
        townInput.dataset.area = data.area || '';
        townInput.dataset.window = data.windowCode || '';
        townInput.dataset.windowFull = data.windowFull || '';

        if (townPickerLabel) {
          townPickerLabel.textContent = data.town || 'Select your delivery town';
        }
      }
    }

    if (accommodationNameInput) accommodationNameInput.value = data.accommodationName || '';
    if (fullAddressInput) fullAddressInput.value = data.fullAddress || '';
    if (deliveryDateInput) deliveryDateInput.value = data.deliveryDate || '';
    if (customerWhatsappPrefix) customerWhatsappPrefix.value = data.whatsappPrefix || '+39';
    if (customerWhatsappNumber) customerWhatsappNumber.value = data.whatsappNumber || '';
    if (deliveryNotesInput) deliveryNotesInput.value = data.deliveryNotes || '';

    const checkbox = getDeliveryPolicyCheckbox();
    if (checkbox) {
      checkbox.checked = data.policyAccepted === 'YES';
      updateDeliveryPolicyAttribute();
    }

    updateLegacyAttributes();
    updateCheckoutInfoBox();
    updateDeliveryWindowFromTown();
  } catch (error) {
    console.warn('WineHoliday: could not restore delivery form draft.', error);
  }
}
function updateDateHelpText(area) {
  const dateHelp = document.getElementById('wh-date-help');
  if (!dateHelp) return;

  const normalizedArea = String(area || '').trim().toUpperCase();

  if (normalizedArea === 'AREA_A' || normalizedArea === 'AREA_B') {
    dateHelp.textContent =
      'Choose your delivery day. Deliveries are available every day except Tuesday.';
    return;
  }

  if (
    ['AREA_C', 'AREA_D', 'AREA_E', 'AREA_F', 'AREA_G'].includes(normalizedArea)
  ) {
    dateHelp.textContent =
      'Choose your delivery day. Deliveries are available Monday, Wednesday, Thursday and Friday.';
    return;
  }

  dateHelp.textContent = 'Choose your delivery day.';
}
function updateDeliveryConditions(townData) {
  const box = document.getElementById('wh-delivery-conditions');
  const title = document.getElementById('wh-delivery-conditions-title');
  const minimum = document.getElementById('wh-delivery-minimum');
  const fee = document.getElementById('wh-delivery-fee');
  const free = document.getElementById('wh-delivery-free');

  if (!box || !title || !minimum || !fee || !free) return;

  if (!townData || !townData.town || !townData.area) {
    box.style.display = 'none';
    return;
  }

  const conditions = {
    AREA_A: {
      minimum: '€69',
      fee: '€7.90',
      free: '€120'
    },
    AREA_B: {
      minimum: '€69',
      fee: '€7.90',
      free: '€120'
    },
    AREA_C: {
      minimum: '€99',
      fee: '€14.90',
      free: '€180'
    },
    AREA_D: {
      minimum: '€169',
      fee: '€19.90',
      free: '€250'
    },
    AREA_E: {
      minimum: '€229',
      fee: '€19.90',
      free: '€299'
    },
    AREA_F: {
      minimum: '€169',
      fee: '€19.90',
      free: '€250'
    },
    AREA_G: {
      minimum: '€169',
      fee: '€19.90',
      free: '€250'
    }
  };

  const data = conditions[townData.area];

  if (!data) {
    box.style.display = 'none';
    return;
  }

  title.textContent = 'Delivery conditions for ' + townData.town;
  minimum.textContent = data.minimum;
  fee.textContent = data.fee;
  free.textContent = data.free;

  box.style.display = 'block';
}

    function updateDeliveryWindowFromTown() {
      const townData = getSelectedTownData(townInput);

      setInputValue(deliveryAreaInput, townData.area);
      setInputValue(deliveryWindowInput, townData.windowFull);
      setInputValue(deliveryWindowFullInput, townData.windowFull);

updateDateHelpText(townData.area);
updateDeliveryConditions(townData);

      if (!deliveryWindowDisplay) return;

      if (!townData.town || !townData.windowFull) {
        deliveryWindowDisplay.textContent = 'Select your delivery town to see your delivery window.';
        deliveryWindowDisplay.style.borderColor = '#d7b56d';
deliveryWindowDisplay.style.background = '#fffaf0';
        return;
      }

      const cleanWindow = townData.windowFull
  .replace('AM1 — ', '')
  .replace('AM2 — ', '')
  .replace('PM — ', '');

      deliveryWindowDisplay.innerHTML =
        '<strong>' + cleanWindow + '</strong><br>' +
        '<span style="font-size:0.9em;">Assigned automatically for ' + townData.town + '.</span>';

      deliveryWindowDisplay.style.borderColor = '#2e7d32';
deliveryWindowDisplay.style.background = '#f1fbf2';
    }

    function validateDeliveryDate() {
  if (!deliveryDateInput || !deliveryDateInput.value) {
    setDateVisualStatus(deliveryDateInput, '');

    if (dateErrorBox) {
      dateErrorBox.style.display = 'none';
      dateErrorBox.textContent = '';
    }

    return false;
  }

  const selectedDate = deliveryDateInput.value;
  const area = deliveryAreaInput ? deliveryAreaInput.value : '';

  if (isPastOrToday(selectedDate)) {
    setDateVisualStatus(deliveryDateInput, 'unavailable');

    if (dateErrorBox) {
      dateErrorBox.style.display = 'block';
      dateErrorBox.textContent =
        '⚠ Please choose a delivery date from tomorrow onwards.';
    }

    return false;
  }

  if (!isDeliveryDayAllowed(selectedDate, area)) {
  setDateVisualStatus(deliveryDateInput, 'unavailable');

  if (dateErrorBox) {
    const normalizedArea = String(area || '').trim().toUpperCase();

    dateErrorBox.style.display = 'block';

    if (!normalizedArea) {
      dateErrorBox.textContent =
        '⚠️ Please select your delivery town first.';
    } else if (
      normalizedArea === 'AREA_A' ||
      normalizedArea === 'AREA_B'
    ) {
      dateErrorBox.textContent =
        '⚠️ Deliveries are not available on Tuesday. Please choose another day.';
    } else {
      dateErrorBox.textContent =
        '⚠️ Deliveries for this area are available only on Monday, Wednesday, Thursday and Friday. Please choose another day.';
    }
  }

  return false;
}

  if (isClosedDate(selectedDate, area)) {
    setDateVisualStatus(deliveryDateInput, 'unavailable');

    if (dateErrorBox) {
      dateErrorBox.style.display = 'block';
      dateErrorBox.textContent =
        '⚠ Deliveries are not available on this date. Please choose another day.';
    }

    return false;
  }

  setDateVisualStatus(deliveryDateInput, 'available');

  if (dateErrorBox) {
    dateErrorBox.style.display = 'none';
    dateErrorBox.textContent = '';
  }

  return true;
}
function getMinimumOrderCents(area) {
  const normalizedArea = String(area || '').trim().toUpperCase();

  const minimums = {
    AREA_A: 6900,
    AREA_B: 6900,
    AREA_C: 9900,
    AREA_D: 16900,
    AREA_E: 22900,
    AREA_F: 16900,
    AREA_G: 16900
  };

  return minimums[normalizedArea] || 0;
}

function formatEuroFromCents(cents) {
  const amount = Number(cents || 0) / 100;
  return '€' + amount.toFixed(amount % 1 === 0 ? 0 : 2);
}

function getCartTotalCentsFromPage() {
  const totalElement = document.querySelector('.totals__total-value');

  if (!totalElement) {
    return Number(window.WH_CART_TOTAL_CENTS || 0);
  }

  let value = String(totalElement.textContent || '')
    .trim()
    .replace(/[^\d,.-]/g, '');

  if (value.includes(',') && value.includes('.')) {
    if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
      value = value.replace(/\./g, '').replace(',', '.');
    } else {
      value = value.replace(/,/g, '');
    }
  } else if (value.includes(',')) {
    value = value.replace(',', '.');
  }

  const amount = Number.parseFloat(value);

  return Number.isFinite(amount)
    ? Math.round(amount * 100)
    : 0;
}

function validateMinimumOrder(showError) {
  const townData = getSelectedTownData(townInput);
  const minimumCents = getMinimumOrderCents(townData.area);
  const cartTotalCents = getCartTotalCentsFromPage();

  if (!minimumCents || cartTotalCents >= minimumCents) {
    if (
      errorBox &&
      errorBox.dataset.whErrorType === 'minimum-order'
    ) {
      errorBox.dataset.whErrorType = '';
      errorBox.style.display = 'none';
    }

    return true;
  }

  if (showError && errorBox) {
    const missingCents = minimumCents - cartTotalCents;

    errorBox.dataset.whErrorType = 'minimum-order';
    errorBox.innerHTML =
      '⚠️ The minimum order for ' + townData.town + ' is ' +
      formatEuroFromCents(minimumCents) + '. ' +
      'Please add ' + formatEuroFromCents(missingCents) +
      ' to continue.';

    errorBox.style.display = 'block';
  }

  return false;
}
    function isDeliveryFormValid(showError) {
      const townData = getSelectedTownData(townInput);
      const whatsapp = updateWhatsappHiddenValues();

      const hasTown = Boolean(townData.town && townData.area && townData.windowFull);
      const hasAccommodationName = Boolean(accommodationNameInput && accommodationNameInput.value.trim());
      const hasFullAddress = Boolean(fullAddressInput && fullAddressInput.value.trim());
      const hasWhatsapp = Boolean(
        customerWhatsappPrefix &&
        customerWhatsappPrefix.value.trim() &&
        customerWhatsappNumber &&
        customerWhatsappNumber.value.trim() &&
        whatsapp
      );
      const hasValidDate = validateDeliveryDate();
      const hasMinimumOrder = validateMinimumOrder(showError);
      const hasAcceptedPolicy = updateDeliveryPolicyError(showError);

      const isValid =
  hasTown &&
  hasAccommodationName &&
  hasFullAddress &&
  hasWhatsapp &&
  hasValidDate &&
  hasMinimumOrder &&
  hasAcceptedPolicy;

      if (errorBox) {
        errorBox.style.display = !isValid && showError ? 'block' : 'none';
      }

      return isValid;
    }
function clearFreshMeatErrorIfNeeded() {
  if (!errorBox || errorBox.dataset.whErrorType !== 'fresh-meat') {
    return;
  }

  errorBox.innerHTML = '⚠️ Please complete your delivery town, accommodation name, full address, delivery date and WhatsApp number before checkout.';
  errorBox.dataset.whErrorType = '';
  errorBox.style.display = 'none';
}
    function updateCheckoutState() {

  updateDeliveryWindowFromTown();
  updateLegacyAttributes();
  updateCheckoutInfoBox();

  const isValid = isDeliveryFormValid(false);

  if (checkoutButton) {
    checkoutButton.disabled = !isValid;
  }

  return isValid;
}

    function continueToCheckoutAfterPolicySave() {
      isSubmittingAfterPolicySave = true;

      if (checkoutButton && typeof checkoutButton.click === 'function') {
        checkoutButton.click();
        return;
      }

      if (cartForm && typeof cartForm.submit === 'function') {
        cartForm.submit();
      }
    }

    function handleSubmit(event) {
  if (isSubmittingAfterPolicySave) {
    return true;
  }

  updateDeliveryWindowFromTown();
  updateLegacyAttributes();
  updateCheckoutInfoBox();

  const isValid = isDeliveryFormValid(true);

  if (!isValid) {
    event.preventDefault();
    event.stopPropagation();

    const policyNote = document.getElementById('wh-delivery-policy-note');

    if (errorBox && errorBox.style.display !== 'none') {
      errorBox.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else if (policyNote) {
      policyNote.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    return false;
  }

  const selectedDeliveryDate = deliveryDateInput ? deliveryDateInput.value.trim() : '';

  if (
    hasFreshMeatProductInCart() &&
    selectedDeliveryDate &&
    !validateFreshMeatDeadline(selectedDeliveryDate)
  ) {
    event.preventDefault();
    event.stopPropagation();

    showFreshMeatDeadlineError();

    return false;
  }

  event.preventDefault();
  event.stopPropagation();

  saveDeliveryPolicyAttributeToCart().then(function () {
    continueToCheckoutAfterPolicySave();
  });

  return false;
}

    function selectTown(optionButton) {
      if (!optionButton || !townInput) return;

      const value = optionButton.dataset.value || '';
      const area = optionButton.dataset.area || '';
      const windowCode = optionButton.dataset.window || '';
      const windowFull = optionButton.dataset.windowFull || '';

      townInput.value = value;
      townInput.dataset.area = area;
      townInput.dataset.window = windowCode;
      townInput.dataset.windowFull = windowFull;

      if (townPickerLabel) {
        townPickerLabel.textContent = value;
      }

      townOptions.forEach(function (button) {
        button.classList.toggle('is-selected', button === optionButton);
      });

      if (townPickerPanel) {
        townPickerPanel.style.display = 'none';
      }

      if (townPickerButton) {
        townPickerButton.setAttribute('aria-expanded', 'false');
      }

      if (townSearch) {
        townSearch.value = '';
      }

      townOptions.forEach(function (button) {
        button.style.display = 'block';
      });

      showAllTownGroups();
      updateCheckoutState();
    }

    function openTownPicker() {
      if (!townPickerPanel || !townPickerButton) return;

      townPickerPanel.style.display = 'block';
      townPickerButton.setAttribute('aria-expanded', 'true');

      if (townSearch) {
        townSearch.value = '';

        townOptions.forEach(function (button) {
          button.style.display = 'block';
        });

        showAllTownGroups();

        setTimeout(function () {
          townSearch.focus();
        }, 50);
      }
    }

    function closeTownPicker() {
      if (!townPickerPanel || !townPickerButton) return;

      townPickerPanel.style.display = 'none';
      townPickerButton.setAttribute('aria-expanded', 'false');
    }

    function toggleTownPicker() {
      if (!townPickerPanel) return;

      const isOpen = townPickerPanel.style.display === 'block';

      if (isOpen) {
        closeTownPicker();
      } else {
        openTownPicker();
      }
    }

    if (townPickerButton && !townPickerButton.dataset.whBound) {
      townPickerButton.dataset.whBound = 'true';

      townPickerButton.addEventListener('click', function () {
        toggleTownPicker();
      });
    }

    townOptions.forEach(function (button) {
      if (button.dataset.whBound) return;

      button.dataset.whBound = 'true';

      button.addEventListener('click', function () {
        selectTown(button);
      });
    });

    if (townSearch && !townSearch.dataset.whBound) {
      townSearch.dataset.whBound = 'true';

      townSearch.addEventListener('input', function () {
        const query = townSearch.value.trim().toLowerCase();

        townOptions.forEach(function (button) {
          const text = button.textContent.trim().toLowerCase();
          button.style.display = text.indexOf(query) !== -1 ? 'block' : 'none';
        });

        updateTownGroupVisibility();
      });
    }

    if (!document.body.dataset.whTownOutsideClickBound) {
      document.body.dataset.whTownOutsideClickBound = 'true';

      document.addEventListener('click', function (event) {
        const activePanel = document.getElementById('wh-town-picker-panel');
        const activeButton = document.getElementById('wh-town-picker-button');

        if (!activePanel || !activeButton) return;

        const clickedInsidePicker = event.target.closest('.wh-town-picker');

        if (!clickedInsidePicker) {
          activePanel.style.display = 'none';
          activeButton.setAttribute('aria-expanded', 'false');
        }
      });
    }

    setMinimumDeliveryDate();
insertDeliveryPolicyNote();
restoreDeliveryFormFromSession();
updateCheckoutState();
  if (!document.body.dataset.whFreshMeatErrorClearBound) {
  document.body.dataset.whFreshMeatErrorClearBound = 'true';

  document.addEventListener('click', function (event) {
    const clickedCartChange = event.target.closest(
      'cart-remove-button, .cart-remove-button, .quantity__button, quantity-input, button[name="minus"], button[name="plus"], a[href*="/cart/change"]'
    );

    if (!clickedCartChange) {
      return;
    }

    if (errorBox && errorBox.dataset.whErrorType === 'fresh-meat') {
      setTimeout(function () {
        saveDeliveryFormToSession();
        window.location.reload();
      }, 1000);
    }
  });
}

if (!document.body.dataset.whMinimumOrderCartReloadBound) {
  document.body.dataset.whMinimumOrderCartReloadBound = 'true';

  let whMinimumOrderReloadTimer = null;

  function scheduleMinimumOrderCartReload() {
    saveDeliveryFormToSession();

    if (whMinimumOrderReloadTimer) {
      clearTimeout(whMinimumOrderReloadTimer);
    }

    whMinimumOrderReloadTimer = setTimeout(function () {
      window.location.reload();
    }, 1200);
  }

  document.addEventListener('click', function (event) {
    const clickedCartChange = event.target.closest(
      'cart-remove-button, .cart-remove-button, .quantity__button, button[name="minus"], button[name="plus"], a[href*="/cart/change"]'
    );

    if (!clickedCartChange) {
      return;
    }

    scheduleMinimumOrderCartReload();
  });

  document.addEventListener('change', function (event) {
    const quantityInput = event.target.closest(
      '.quantity__input, .quantity-input, input[name="updates[]"]'
    );

    if (!quantityInput) {
      return;
    }

    scheduleMinimumOrderCartReload();
  });
}

    if (accommodationNameInput) {
      accommodationNameInput.oninput = updateCheckoutState;
      accommodationNameInput.onchange = updateCheckoutState;
    }

    if (fullAddressInput) {
      fullAddressInput.oninput = updateCheckoutState;
      fullAddressInput.onchange = updateCheckoutState;
    }
if (deliveryDateInput) {
  deliveryDateInput.onchange = function () {
    clearFreshMeatErrorIfNeeded();
    updateCheckoutState();
  };

  deliveryDateInput.oninput = function () {
    clearFreshMeatErrorIfNeeded();
    updateCheckoutState();
  };
}

    if (customerWhatsappPrefix) {
      customerWhatsappPrefix.onchange = updateCheckoutState;
    }

    if (customerWhatsappNumber) {
      customerWhatsappNumber.oninput = updateCheckoutState;
      customerWhatsappNumber.onchange = updateCheckoutState;
    }

    if (deliveryNotesInput) {
      deliveryNotesInput.oninput = updateCheckoutState;
      deliveryNotesInput.onchange = updateCheckoutState;
    }

    if (cartForm) {
      cartForm.onsubmit = handleSubmit;
    }
  }

  document.addEventListener('DOMContentLoaded', initWineHolidayDeliveryFlow);

  document.addEventListener('shopify:section:load', function () {
    initWineHolidayDeliveryFlow();
  });

  document.addEventListener('cart:updated', function () {
    initWineHolidayDeliveryFlow();
  });

  window.WH_initDeliveryFlow = initWineHolidayDeliveryFlow;
})();document.addEventListener('DOMContentLoaded', function () {
  if (document.body.dataset.whMixedCartReloadBound === 'true') {
    return;
  }

  document.body.dataset.whMixedCartReloadBound = 'true';

  function whHasMixedCartWarning() {
    const pageText = document.body.textContent || '';

    return (
      pageText.includes('Private tastings and villa deliveries must be booked separately') ||
      pageText.includes('Please separate tasting and delivery orders')
    );
  }

  function whIsCartChangeClick(event) {
    return event.target.closest(
      'cart-remove-button, .cart-remove-button, .quantity__button, quantity-input, button[name="minus"], button[name="plus"], a[href*="/cart/change"], a[href*="/cart/clear"]'
    );
  }

  document.addEventListener('click', function (event) {
    if (!whIsCartChangeClick(event)) {
      return;
    }

    if (!whHasMixedCartWarning()) {
      return;
    }

    setTimeout(function () {
      window.location.reload();
    }, 900);
  });

  document.addEventListener('change', function (event) {
    if (!whHasMixedCartWarning()) {
      return;
    }

    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.matches('.quantity__input')
    ) {
      setTimeout(function () {
        window.location.reload();
      }, 900);
    }
  });
});